// extracted by mini-css-extract-plugin
export default {"wrapper":"ServicesReason_wrapper__1pqko","title":"ServicesReason_title__GlkXb","informationList":"ServicesReason_informationList__5JIHD"};